import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AlarmClock, CalendarX, Clock, TimerReset, UserCheck, Users } from "lucide-react";
import { StatCard } from "../../components/neu/StatCard";
import { NeuPicker } from "../../components/neu/NeuPicker";
import { AttendanceChart } from "../admin/AttendanceChart";
import { useReportData } from "../admin/useReportData";
import { useTodaySummary } from "./useTodaySummary";

// Cards show TODAY only and open the dedicated /today screen; the chart shows the 14-day trend.
export const DashboardSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { rows: trendRows, branches, loading } = useReportData(14);
  const [branchId, setBranchId] = useState("");
  const { summary, employees, date } = useTodaySummary(branchId);
  const s = summary || {};

  // ست بطاقات KPI ملوّنة (نغمات فريدة): موظفون=أزرق، حاضرون=أخضر، غياب=وردي، تأخير=كهرماني،
  // ساعات=بنفسجي، وقت إضافي=برتقالي.
  const cards = [
    { key: "employees",   value: employees.length,                                       icon: Users,      tone: "sky" },
    { key: "present",     value: s.present_employees ?? 0,                                icon: UserCheck,  tone: "emerald" },
    { key: "absent",      value: Math.max(0, employees.length - (s.present_employees ?? 0)), icon: CalendarX, tone: "rose" },
    { key: "lateRecords", value: s.late_records ?? 0,                                     icon: AlarmClock, tone: "amber" },
    { key: "totalHours",  value: ((s.total_worked_minutes ?? 0) / 60).toFixed(1),          icon: Clock,      tone: "violet" },
    { key: "overtime",    value: ((s.total_overtime_minutes ?? 0) / 60).toFixed(1),        icon: TimerReset, tone: "orange" },
  ];

  const open = (key) => navigate(`/today?tab=${key}${branchId ? `&branch=${branchId}` : ""}`);

  return (
    <section className="grid gap-4" data-testid="dashboard-section">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="label-xs">{t("dashboard.title")}</p>
          <p className="mt-1 text-sm text-muted-foreground" data-testid="dashboard-today">
            {t("dashboard.todayNote")} <span className="font-mono" dir="ltr">{date}</span> · {t("dashboard.tapHint")}
          </p>
        </div>
        <NeuPicker className="min-w-48" testId="dashboard-branch-filter"
                   value={branchId} onChange={(e) => setBranchId(e.target.value)}>
          <option value="">{t("dashboard.allBranches")}</option>
          {branches.map((b) => (
            <option key={b.id} value={b.id}>
              {b.name}
            </option>
          ))}
        </NeuPicker>
      </div>

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-6" data-testid="dashboard-stats">
        {cards.map((c) => (
          <StatCard
            key={c.key}
            testId={`stat-${c.key}`}
            label={t(`dashboard.${c.key}`)}
            value={c.value}
            icon={c.icon}
            tone={c.tone}
            onClick={() => open(c.key)}
          />
        ))}
      </div>

      {loading ? (
        <p className="text-sm text-muted-foreground">{t("app.loading")}</p>
      ) : (
        <AttendanceChart rows={trendRows} />
      )}
    </section>
  );
};
